import { Duration } from 'luxon';

export function formatTime(timeInSeconds: number): string {
  // Guard against non-finite input (e.g. HTMLMediaElement.duration === Infinity
  // for streaming/unseekable media); Luxon throws "Invalid unit value Infinity".
  const safeSeconds = Number.isFinite(timeInSeconds) ? timeInSeconds : 0;
  const duration = Duration.fromMillis(safeSeconds * 1000);
  return duration.toFormat('hh:mm:ss:SSS');
}

export function calculateCPS(
  text: string,
  start: number,
  stop: number
): string {
  // Calculate the duration in seconds
  const durationInSeconds = (stop - start) / 1000;

  // Zero-duration cues (start === stop) would divide by zero and render
  // "Infinity"/"NaN" in the UI. Treat them as 0 chars-per-second.
  if (!Number.isFinite(durationInSeconds) || durationInSeconds <= 0) {
    return '0';
  }

  // Calculate the number of characters in the given duration (1 second)
  const numberOfCharactersInOneSecond = text.length / durationInSeconds;

  return Math.round(numberOfCharactersInOneSecond).toString(); // Return as a string
}
